import "ace-builds";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import AceEditor from "react-ace";
import { isNotNullDefined } from "utils/isDefined.ts";

const LINES_COUNT = 3;

interface ResponseBodyRendererProps {
    response: unknown;
    id: string;
    lines?: number;
    fill?: boolean;
}

export const ApiResponseBodyCell = ({ response, id, lines = LINES_COUNT, fill = false }: ResponseBodyRendererProps) => {
    let body: string | object | null = null;

    if (
        typeof response === "object" &&
        isNotNullDefined(response) &&
        "body" in response &&
        (typeof response.body === "string" || typeof response.body === "object")
    ) {
        body = response.body;
    }

    return (
        <AceEditor
            name={id}
            mode={"json"}
            theme="github"
            value={formatResponseBody(body)}
            {...(fill ? { height: "100%" } : { minLines: lines, maxLines: lines })}
            className={"min-w-[318px] !w-full"}
            wrapEnabled
            readOnly
        />
    );
};

function formatResponseBody(body: string | object | null) {
    if (!body) {
        return;
    }

    if (typeof body === "string") {
        return JSON.stringify(body, null, 2);
    }

    return Object.entries(body)
        .map(([key, value]) => `"${key}": ${JSON.stringify(value, null, 2)}`)
        .join(",\n");
}
